
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/d8570c98-0eed-4e42-996f-c57f55095658.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('d8570c98-0eed-4e42-996f-c57f55095658');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      